import { useEffect, useRef, useState } from "react";
import { ChevronDown, X } from "lucide-react";

export default function MultiSelectFilter({ label, values, onChange, options, testid, disabled = false, placeholder = "Tümü", className = "", emptyText = "Seçenek yok", noun = "bölge" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  const toggle = (v) => onChange(values.includes(v) ? values.filter((x) => x !== v) : [...values, v]);
  const allSelected = options.length > 0 && values.length === options.length;
  const selected = values.map((v) => options.find((o) => o.value === v) || { value: v, label: v });
  const summary = values.length === 0 ? placeholder : allSelected ? `Tümü (${values.length} ${noun})` : values.length === 1 ? selected[0].label : `${values.length} ${noun} seçili`;
  return (
    <div className={`space-y-1 relative ${className}`} ref={ref}>
      <label className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{label}</label>
      <button type="button" data-testid={testid} disabled={disabled} onClick={() => setOpen(!open)} title={selected.length ? selected.map((o) => o.label).join(", ") : undefined}
        className="w-full px-2.5 py-1.5 text-xs border border-slate-300 rounded-md bg-white text-left flex items-center justify-between gap-2 disabled:bg-slate-50 disabled:text-slate-400">
        <span className={values.length === 1 ? "break-words" : "truncate"}>{summary}</span>
        <ChevronDown className="w-3.5 h-3.5 text-slate-400 shrink-0" />
      </button>
      {open && !disabled && (
        <div className="absolute z-30 mt-1 w-full bg-white border border-slate-200 rounded-md shadow-lg" data-testid={`${testid}-dropdown`}>
          <div className="flex items-center justify-between px-3 py-1.5 border-b border-slate-100">
            <span className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold">{values.length > 0 ? `${values.length} seçili` : "Tümü dahil"}</span>
            {values.length > 0 && <button type="button" onClick={() => onChange([])} data-testid={`${testid}-clear`} className="text-[10px] font-semibold text-red-600 hover:text-red-800">Temizle</button>}
          </div>
          <div className="max-h-52 overflow-y-auto">
            {options.map((o) => (
              <label key={o.value} data-testid={`${testid}-opt-${o.value}`} className="flex items-center gap-2 px-3 py-1.5 text-xs cursor-pointer hover:bg-amber-50">
                <input type="checkbox" checked={values.includes(o.value)} onChange={() => toggle(o.value)} className="accent-amber-600 w-3.5 h-3.5" />
                <span className="truncate">{o.label}</span>
              </label>
            ))}
            {options.length === 0 && <div className="px-3 py-3 text-xs text-slate-500" data-testid={`${testid}-empty`}>{emptyText}</div>}
          </div>
        </div>
      )}
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-1 pt-0.5" data-testid={`${testid}-chips`}>   {/* seçili bölgeler altta kutucuk olarak; × filtreden de çıkarır, yeniden seçilince kutu geri gelir */}
          {selected.map((o) => (
            <span key={o.value} className="inline-flex items-center gap-1 max-w-full px-2 py-0.5 rounded-md bg-amber-100 text-amber-900 text-[11px] font-semibold border border-amber-200" data-testid={`${testid}-chip-${o.value}`}>
              <span className="truncate">{o.label}</span>
              {!disabled && <button type="button" onClick={() => onChange(values.filter((x) => x !== o.value))} data-testid={`${testid}-chip-remove-${o.value}`} title={`${o.label} seçimini kaldır`} className="text-amber-700 hover:text-red-700 leading-none rounded hover:bg-amber-200/70 p-0.5 -mr-1"><X className="w-3 h-3" /></button>}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
